import { useMutation } from '@zenbusiness/application-commons-graphql';

import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useLogError } from '#client/hooks/useLogError';
import { CREATE_ASTRA_TOKEN_MUTATION } from '#client/mutations';

const useCreateAstraToken = () => {
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const [mutation, { data, loading, error, errors }] = useMutation(CREATE_ASTRA_TOKEN_MUTATION, {
    noThrow: true
  });

  useLogError(errors, error);

  const createAstraToken = async () => {
    const response = await mutation({
      variables: {
        businessEntityUuid
      }
    });

    return response?.data?.createInstantFundingAuthTokens?.accessToken;
  };

  return {
    createAstraToken,
    data,
    loading,
    error
  };
};

export default useCreateAstraToken;
